<template>
  <div class="pa-park-invitation-code-banner" v-if="parkInvitation">
    <div class="code-field">
      <form>
        <input
         type="text"
         :value="parkInvitation.invitation_code"
         @focus="handleFocusInput"
        />
      </form>
    </div>
    <div class="info-field">
      <p>異世界地球時間{{parkInvitation.expire_at|mutateJPFullWidthDateTime}}迄有効</p>
    </div>
    <div class="control-field">
      <div class="left-side">
        <button
         class="button pa-button"
         :class="additionalDeleteButtonClass"
         :disabled="isDisabledDeleteButton"
         @click.prevent="handleClickDeleteButton"
        >削除</button>
      </div>
      <div class="right-side">
        <button
          class="button pa-button"
          :class="additionalCopyButtonClass"
          :disabled="isDisableCopyButton"
          @click.prevent="handleClickCopyButton"
        >{{copyButtonText}}</button>
      </div>
    </div>
  </div>
</template>

<script>
import {GetParkInvitation} from '@/graphql/queries/Park.graphql'

import {DeleteInvitationCode} from '@/graphql/mutations/Park.graphql'

export default {
  props : {
    parkInvitationId : {
      default: null
    }
  },

  data(){
    return {
      copyButtonText            : '番号をコピーする',
      copyButtonTextTemplate    : {
        normal  : '番号をコピーする',
        finish  : '番号をコピー致しました。'
      },
      isLoadingCopyButton       : false,
      additionalCopyButtonClass : {
        'is-loading'  : false
      },
      isDisableCopyButton       : false,

      isLoadingDeleteButton       : false,
      additionalDeleteButtonClass : {
        'is-loading'  : false
      },
      isDisabledDeleteButton      : false,
    }
  },

  watch : {
    isLoadingCopyButton : {
      handler(value){
        this.additionalCopyButtonClass['is-loading'] = value;
        this.isDisableCopyButton = value;
      }
    },

    isLoadingDeleteButton : {
      handler(value){
        this.additionalDeleteButtonClass['is-loading'] = value;
        this.isDisabledDeleteButton = value;
      }
    }
  },

  apollo : {
    parkInvitation : {
      query : GetParkInvitation,
      variables(){
        return {
          id  : this.parkInvitationId
        }
      },
      skip(){
        if(this.parkInvitationId === null){
          return true;
        }else{
          return false;
        }
      }
    }
  },

  methods : {
    handleFocusInput(event){
      event.target.select();
    },

    async handleClickDeleteButton(){
      this.isLoadingDeleteButton = true;

      await this.UXWaiting(200);

      if( confirm('選択した番号を削除してもよろしいですか？') ){
        await this.UXWaiting(800);

        const result = await this.executeDeleteInvitationCode();

        if(result === true){
          this.$store.dispatch({
            type        : 'flashMessage/updateFlashMessage',
            hasMessage  : true,
            message     : '&nbsp;通行手形を削除致しました。',
            status      : 'success',
            hasControl  : true,
            autoClose   : 8000
          }, {root:true});
        }else{
          this.$store.dispatch({
            type        : 'flashMessage/updateFlashMessage',
            hasMessage  : true,
            message     : '&nbsp;エラーが発生しました。',
            status      : 'error',
            hasControl  : true,
            autoClose   : 8000
          }, {root:true});
        }

        this.isLoadingDeleteButton = false;

        this.$emit('onDeleteInvitation');
      }else{
        this.isLoadingDeleteButton = false;
      }
    },

    async handleClickCopyButton(){
      this.isLoadingCopyButton = true;
      
      await this.UXWaiting(800);

      this.executeCopyTextForClipboard(this.parkInvitation.invitation_code);

      this.isLoadingCopyButton = false;

      this.copyButtonText = this.copyButtonTextTemplate.finish;
      await this.UXWaiting(1000);
      this.copyButtonText = this.copyButtonTextTemplate.normal;
    },

    executeCopyTextForClipboard(copyText){
      const textArea = document.createElement('textarea');
      textArea.value = copyText;
  
      // Avoid scrolling to bottom
      textArea.readOnly = true;
      textArea.contentEditable = true;

      textArea.style.position = 'fixed';
      textArea.style.top      = 0;
      textArea.style.left     = 0;
      textArea.style.opacity  = 0;

      document.body.appendChild(textArea);

      let iosSelection = null;

      if(navigator.userAgent.match(/ipad|iphone/i)){
        const range = document.createRange();
        range.selectNodeContents(textArea);
        
        iosSelection = window.getSelection();
        iosSelection.removeAllRanges();
        iosSelection.addRange(range);
        textArea.setSelectionRange(0, 999999);
      }else{
        textArea.focus();
        textArea.select();
      }
    },

    executeDeleteInvitationCode(){
      return new Promise((resolve) => {
        this.$apollo.mutate({
          mutation  : DeleteInvitationCode,
          variables : {
            parkInvitationId  : this.parkInvitationId
          }
        }).then(async ({data: {DeleteInvitationCode: {result}}}) => {
          resolve(result);
        }).catch(async (error) => {
          console.error(error);

          resolve(false);
        });
      });
    }
  }
}
</script>

<style lang="scss">
.pa-park-invitation-code-banner{
  background-color: #C8A984;
  border-radius: 4px;

  .code-field{
    width:95%;
    margin:0 auto;
    border-bottom:1px solid #B0906A;
    form{
      input{
        display: block;
        width:100%;
        height: inherit;
        margin:0;
        padding:.2rem 0;
        border:0;
        background-color: inherit;
        color:#7C5E49;
        text-align: center;
        font-size: 1.5rem;
        line-height: 1;
        font-family: 'mplus-1m-medium';

        &:focus-visible{
          outline: none;
        }

        &::selection{
          color:#F0D4B3;
        }
      }
    }

    p{
      color:#7C5E49;
      text-align: center;
      font-size: 1.5rem;;
    }
  }
  
  .info-field{
    p{
      text-align: right;
      width:95%;
      margin:0 auto;
      padding:4px 8px 4px;
      color:#7C5E49;
      font-size:.6rem;
    }
  }

  .control-field{
    display: flex;
    padding:.3rem 0 .5rem;

    .left-side{
      width:35%;
    }

    .right-side{
      width:65%;
    }

    button.pa-button{
      display: block;
      width:95%;
      border:0;
      margin:0 auto;
      padding:.1rem 0;
      height:inherit;
      font-size: .8rem;
      background-color: #C49E71;
      color: #7B6141;

      transition:border-bottom .25s ease-in-out;
      transition:font-weight .25s ease-in-out;
      transition:color .25s ease-in-out;

      &.is-loading{
        &::after{
          border: 1.3px solid #7B6141;
          border-right-color: transparent;
          border-top-color: transparent;
        }
      }
    }
  }
}
</style>